import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { getIsNewDraft } from './utils/api/QualifiedLeadsApi';
import { Flex } from 'foundations-components/components/Flex';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Z_INDEX = {
  REGULAR: '1111',
  INVISIBLE: '-1000'
};
function getSourceUrl(appName, contactVid, chatThreadId) {
  const baseUrl = `/qualified-leads-ui/${PortalIdParser.get()}/drafts/${contactVid}?appName=${appName}`;
  if (chatThreadId) {
    return `${baseUrl}&chatThreadId=${chatThreadId}`;
  } else {
    return baseUrl;
  }
}
function RaiseALeadButton({
  alertStore,
  appName,
  chatThreadId = 0,
  contactVid = 0
}) {
  const [isNewDraft, setNewDraft] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [isLoadingDraft, setLoadingDraft] = useState(false);
  const [isLoadingMeta, setLoadingMeta] = useState(false);
  useEffect(() => {
    getIsNewDraft(contactVid).then(result => setNewDraft(result === 'true')).catch(__ => {});
  }, [contactVid, isOpen]);
  useEffect(() => {
    const handleWindowEvents = event => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const {
        data
      } = event;
      if (!data.payload || `${data.payload.leadContactVid}` !== `${contactVid}`) {
        return;
      }
      switch (data.type) {
        case 'QL_PANEL_CLOSE_REQUESTED':
          setOpen(false);
          break;
        case 'QL_PANEL_DRAFT_LOADED':
          setLoadingDraft(false);
          break;
        case 'QL_PANEL_META_LOADED':
          setLoadingMeta(false);
          break;
        case 'QL_PANEL_SUBMISSION_CREATED':
          setNewDraft(true);
          setOpen(false);
          alertStore.addAlert(data.payload.alert);
          break;
        case 'QL_PANEL_CONTACT_OWNER_REASSIGNMENT_DELAYED':
        case 'QL_PANEL_CONTACT_OWNER_REASSIGNED':
        case 'QL_PANEL_DOMAIN_EDITED':
        case 'QL_PANEL_DOMAIN_ENRICHED':
        case 'QL_PANEL_MEETING_BOOKED':
        case 'QL_PANEL_SUBMISSION_FAILED':
          alertStore.addAlert(data.payload.alert);
          break;
        default:
          break;
      }
    };
    setOpen(false);
    window.addEventListener('message', handleWindowEvents, false);
    return () => {
      window.removeEventListener('message', handleWindowEvents);
    };
  }, [alertStore, contactVid]);
  const handleOnClick = () => {
    setOpen(true);
    setLoadingDraft(true);
    setLoadingMeta(true);
  };
  const isValidContactVid = contactVid && /^\d+$/.test(String(contactVid));
  const isLoading = isLoadingDraft || isLoadingMeta;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOpen && /*#__PURE__*/_jsx(Panel, {
      animate: false,
      "data-test-id": "panel",
      width: 316,
      containerZIndex: isLoading ? Z_INDEX.INVISIBLE : Z_INDEX.REGULAR,
      children: /*#__PURE__*/_jsx(Flex, {
        position: "fixed",
        inset: "0",
        children: /*#__PURE__*/_jsx("iframe", {
          height: "100%",
          width: "100%",
          frameBorder: 0,
          src: getSourceUrl(appName, contactVid, chatThreadId)
        })
      })
    }), /*#__PURE__*/_jsx(UILoadingButton, {
      "data-test-id": "button",
      disabled: isOpen || !isValidContactVid,
      loading: isLoading,
      onClick: handleOnClick,
      size: "small",
      use: "tertiary",
      children: isNewDraft ? 'Raise a lead' : 'Continue raising lead'
    })]
  });
}
RaiseALeadButton.propTypes = {
  alertStore: PropTypes.any.isRequired,
  appName: PropTypes.string.isRequired,
  chatThreadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default RaiseALeadButton;